/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Posture_Exact_ListInputs */



/**
* | output |
* | --- |
* | "Only enabled tools" |
*
* @param {Rights_Tools_Posture_Exact_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_posture_exact_list = /** @type {((inputs?: Rights_Tools_Posture_Exact_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Posture_Exact_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur freigegebene Tools")
	return /** @type {LocalizedString} */ ("Only enabled tools")
});